module.exports = __webpack_public_path__ + "static/media/beep.b76b0645.mp3";